import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const EMPTY = { name: "", contact_person: "", phone: "", email: "", address: "", allocation: "", notes: "", is_active: true };
const FIELDS = [["name", "Hospital Partner name"], ["contact_person", "Contact person"], ["phone", "Phone"], ["email", "Email"]];

export const HospitalFormDialog = ({ open, hospital, onClose, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setF(hospital ? { ...EMPTY, ...hospital } : EMPTY); }, [open, hospital]);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));

  const save = async () => {
    if (f.name.trim().length < 2) return toast.error("Enter the hospital partner name");
    if (!hospital && (f.allocation === "" || Number(f.allocation) < 0)) return toast.error("Enter the approved supply allocation");
    const body = { name: f.name, contact_person: f.contact_person, phone: f.phone, email: f.email, address: f.address,
      allocation: hospital ? null : Number(f.allocation), notes: f.notes, is_active: f.is_active };
    setSaving(true);
    try {
      hospital ? await api.put(`/wholesale/hospitals/${hospital.id}`, body) : await api.post("/wholesale/hospitals", body);
      toast.success("Hospital Partner saved"); onSaved(); onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="ws-hospital-dialog">
        <DialogHeader><DialogTitle>{hospital ? `Edit ${hospital.name}` : "New Hospital Partner"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={k === "name" ? "col-span-2" : ""}><Label className="text-xs">{label}</Label><Input data-testid={`ws-hospital-${k}`} value={f[k]} onChange={(e) => set(k, e.target.value)} /></div>
          ))}
          <div className="col-span-2"><Label className="text-xs">Address</Label><Input data-testid="ws-hospital-address" value={f.address} onChange={(e) => set("address", e.target.value)} /></div>
          {!hospital && <div><Label className="text-xs">Approved supply allocation (GHS)</Label><Input type="number" min="0" step="0.01" data-testid="ws-hospital-allocation" value={f.allocation} onChange={(e) => set("allocation", e.target.value)} /></div>}
          <div className="flex items-end gap-2 pb-2"><Switch checked={f.is_active} onCheckedChange={(v) => set("is_active", v)} data-testid="ws-hospital-active" /><Label>Active</Label></div>
          <div className="col-span-2"><Label className="text-xs">Notes</Label><Textarea rows={2} value={f.notes} onChange={(e) => set("notes", e.target.value)} /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={saving} data-testid="ws-hospital-save-btn">{saving ? "Saving…" : "Save"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
